"use client";
import MainLayout from "@/components/layout/mainLayout";
import { useEffect, useState } from "react";
import BuyNowCart from "@/components/common/BuyNowCart";
import SignupForFree from "@/components/landingpage/SignupForFree";
import InvigoratedDetails from "@/components/newoctavecollection/InvigoratedDetails";
import NewCollectionBanner from "@/components/newoctavecollection/NewCollectionBanner";
import TheJourneyDetails from "@/components/newoctavecollection/TheJourneyDetails";
import TheWhiskyCollection from "@/components/newoctavecollection/TheWhiskyCollection";
import WhiskyDetailsCard from "@/components/newoctavecollection/WhiskyDetailsCard";
import { getCheckoutLineItems } from "@/util/utils";
import OctaveDetailsSection from "@/components/newoctavecollection/OctaveDetailsSection";
import ScoMeta from "@/components/scometa";
import OwnACaskModal from "@/components/newoctavecollection/OwnACaskModal";
import ThanksCaskModal from "@/components/newoctavecollection/ThanksCaskModal";
import { useAppCommonStore } from "@/zustand/appCommon";

const OctaveCollection = (props: any) => {
  const { data, meta } = props;
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  const [octavecollectionData, setOctavecollectionData]: any =
    useState(null);
  const [openOwnCaskModal, setOpenOwnCaskModal]: any =
    useState(false);
  const [openCaskThanksModal, setOpenCaskThanksModal]: any =
    useState(false);

  useEffect(() => {
    if (data) {
      setOctavecollectionData(data?.data?.attributes?.blocks);
    }
  }, [data]);
  const renderOctaveCollectionPage = () => {
    return (
      <>
        {octavecollectionData && octavecollectionData.length
          ? octavecollectionData.map((content: any, index: any) => {
              switch (content.__component) {
                case "sections.banner":
                  return (
                    <div key={index}>
                      <NewCollectionBanner data={content} />
                    </div>
                  );

                // case "octave.about-the-collection":
                //   return (
                //     <CaskDetails key={content?.id + index} data={content} />
                //   );

                // case "octave.video-section":
                //   let videosrc = content.video_link;
                //   return (
                //     <div key={index}  className="octave_banner">
                //       <BannerVideo srcURL={videosrc} data={content} />
                //     </div>
                //   );
                case "octave.about-the-collection":
                  return (
                    <OctaveDetailsSection
                      key={content?.id + index}
                      data={content}
                    />
                  );

                case "octave.how-collection-made":
                  return (
                    <InvigoratedDetails
                      key={content?.id + index}
                      data={content}
                    />
                  );
                case "octave.our-collections":
                  return (
                    <TheWhiskyCollection
                      key={content?.id + index}
                      data={content}
                    />
                  );
                case "octave.journey":
                  return (
                    <TheJourneyDetails
                      key={content?.id + index}
                      data={content}
                    />
                  );
                // case "octave.journey-whiskey":
                //   return (
                //     <WhiskyDetailsCard
                //       key={content?.id + index}
                //       data={content}
                //     />
                //   );
                // case "octave.highland-park":
                //   return (
                //     <FeaturedBanner key={content?.id + index} data={content} />
                //   );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  const toggleOwnCaskModal = () => {
    setOpenOwnCaskModal(!openOwnCaskModal);
  };
  return (
    <>
      <button className="own_octave_btn" onClick={toggleOwnCaskModal}>
        {/* <h2>Own a </h2> */}
        <h3>Create your Own</h3>
      </button>
      <OwnACaskModal
        openOwnCaskModal={openOwnCaskModal}
        toggleOwnCaskModal={toggleOwnCaskModal}
        setOpenCaskThanksModal={setOpenCaskThanksModal}
      />
      <ThanksCaskModal
        openModal={openCaskThanksModal}
        setOpenModal={setOpenCaskThanksModal}
      />
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      <MainLayout
        checkout={checkout}
        toggleCartSidebar={toggleCartSidebar}
      >
        <div className="new-octave-collection">
          {octavecollectionData && renderOctaveCollectionPage()}
          <SignupForFree />
        </div>
      </MainLayout>
    </>
  );
};

export default OctaveCollection;
